import { Button, Callout, Intent, Tag } from '@blueprintjs/core';
import { Classes, Popover2, Popover2InteractionKind } from '@blueprintjs/popover2';
import React, { useState } from 'react';

import { apiClient, apiQueryClient } from '@f/api-client';
import { MultiSelect } from '@f/components/shared/select';

import cls from './ShareButton.module.css';

export function ShareButton(props) {
  const { item } = props;
  const searchId = item.id;

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<string[]>(item.shareInfo.userIds);

  const allUsersQuery = apiQueryClient.user.organizationUsers.useQuery(['organizationUsers']);

  const onPopupOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    setPopupOpen(true);
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onChange = (selectedItems: Array<{ id: string; email: string }>) => {
    setSelectedUsers(selectedItems.map(item => item.id));
  };

  const onSave = async () => {
    const params = { searchId: item.id };
    const body = selectedUsers;
    await apiClient.search.shareSearch({ params, body });
    setPopupOpen(false);
  };

  const failedToLoadUsers = allUsersQuery.data?.status !== 200;
  const noUsersToShare = allUsersQuery.data?.body.length === 0;
  const popoverDisabled = allUsersQuery.isLoading || failedToLoadUsers || noUsersToShare;

  return (
    <div className={cls.buttonContainer} onClick={event => event.stopPropagation()}>
      <Popover2
        portalStopPropagationEvents={['click']}
        isOpen={isPopupOpen}
        onClose={onPopupClose}
        interactionKind={Popover2InteractionKind.CLICK}
        disabled={popoverDisabled}
        content={
          <div className={cls.container}>
            <Callout intent={Intent.PRIMARY}>Select users to share this search with.</Callout>
            <MultiSelect
              containerClassName={cls.selectContainer}
              large
              outlined
              enableSelectAll
              enableSelectNone
              items={allUsersQuery.isLoading ? [] : allUsersQuery.data?.body}
              selectedItemIds={selectedUsers}
              idField="id"
              labelField="email"
              buttonProps={(activeItems: never[], items: never[]) => {
                return {
                  text: (
                    <>
                      <Tag round minimal>
                        {`${activeItems.length}/${items.length}`}
                      </Tag>{' '}
                      Users
                    </>
                  ),
                };
              }}
              onChange={onChange}
              key={searchId}
            />
            <Button
              large={true}
              type="button"
              onClick={onSave}
              intent={Intent.PRIMARY}
              text="Save"
              icon="floppy-disk"
            />
          </div>
        }
        placement="bottom-start"
        popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
      >
        <Button
          minimal
          icon="share"
          active={isPopupOpen}
          onClick={onPopupOpen}
          disabled={popoverDisabled}
          loading={allUsersQuery.isLoading}
        />
      </Popover2>
    </div>
  );
}
